import util from '@bmp-vue/core/api/util'
const controller = 'Stone'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
})
